// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(import.meta.env.VITE_APP_BASE_URL)
// ** START:  
export const getVendorListF01Data = createAsyncThunk('appVendor/getVendorListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        if (!state.vendor.vendorListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/vendor/get-vendor-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getVendorListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Vendor/GetVendorListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.vendor.vendorListF01.allData
            tempIsDataLoaded = state.vendor.vendorListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:

        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            if (a[sortColumn]) {
                return a[sortColumn] < b[sortColumn] ? -1 : 1
            } else {
                const splitColumn = sortColumn.split('.')
                const columnA = a[splitColumn[0]][splitColumn[1]]
                const columnB = b[splitColumn[0]][splitColumn[1]]
                return columnA < columnB ? -1 : 1
            }
        })

        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            vendor => { 
                return ((vendor.name.toLowerCase().includes(queryLowered) ||
                        vendor.contact.toLowerCase().includes(queryLowered) ||
                        vendor.email.toLowerCase().includes(queryLowered)) 
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const vendorListF01Slice = createSlice({
    name: 'vendorListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getVendorListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getVendorListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getVendorListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getVendorListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }

    })
    }
})

// ** START:  
export const getVendorRowF01Data = createAsyncThunk('appVendor/getVendorRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/vendor/get-vendor-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getVendorRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getVendorRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const vendorRowF01Slice = createSlice({
    name: 'vendorRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getVendorRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getVendorRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getVendorRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getVendorRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateVendor = createAsyncThunk('appVendor/updateVendor', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/vendor/update-vendor/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const vendorUpdateSlice = createSlice({
    name: 'vendorUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateVendor.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateVendor.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateVendor.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateVendor:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createVendor = createAsyncThunk('appVendor/createVendor', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/vendor/create-vendor`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const vendorCreateSlice = createSlice({
    name: 'vendorCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createVendor.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createVendor:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createVendor.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createVendor.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createVendor\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteVendor = createAsyncThunk('appVendor/deleteVendor', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/vendor/delete-vendor/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const vendorDeleteSlice = createSlice({
    name: 'vendorDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteVendor.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteVendor.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteVendor.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteVendor:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Export actions
export const { setIsDataLoaded } = vendorListF01Slice.actions
export const { resetCreateState } = vendorCreateSlice.actions

// Combine reducers
const vendorReducer = combineReducers({
    vendorListF01: vendorListF01Slice.reducer,
    vendorRowF01: vendorRowF01Slice.reducer,
    vendorCreate: vendorCreateSlice.reducer,
    vendorUpdate: vendorUpdateSlice.reducer,
    vendorDelete: vendorDeleteSlice.reducer
})


export default vendorReducer